module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M16.404 29.454a5.3 5.3 0 0 1-1.798-.3C3.898 25.37 2.59 18.718 2.544 18.44L2.516 5.928c0-1.866 1.484-3.384 3.316-3.384h15.16V6.03H5.832l.17 12.104c.04 0 1.232 4.718 9.762 7.74.654.218 1.478.006 1.9-.15 8.85-3.24 8.318-7.21 8.312-7.25l-.034-4.15h3.486v3.808c.04 0 1.308 6.522-10.572 10.864-.656.24-1.514.458-2.452.458z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/certification-secondary.js
// module id = 1053
// module chunks = 14